<template>
  <div
    :style="scaleStyle"
    ref="previewMain"
    :class="{ 'is-sample': isSample, 'is-preview': !isSample }"
  >
    <EnglishResumePreviewDoc
      :format-data="formatData"
      :basic-data="basicData"
      :jobs-page1="jobsPage1"
      :full-name="fullName"
      :full-address="fullAddress"
      :full-phone="fullPhone"
      :formated-create-date="formatedCreateDate"
      :highlight-message="highlightMessage"
      :current-card-id="currentCardId"
      :id-prefix="idPrefix"
      :is-sample="isSample"
      :card-changed="cardChanged"
      @go-card-to="goCardTo"
    />
    <EnglishResumePreviewDocPage2
      v-if="isTwoPage"
      :jobs-page2="jobsPage2"
      :full-name="fullName"
      :highlight-message="highlightMessage"
      :current-card-id="currentCardId"
      :id-prefix="idPrefix"
      :is-sample="isSample"
      :card-changed="cardChanged"
      @go-card-to="goCardTo"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { splitJobHistories } from '@/utils/format-edit/englishResumePreview'
import EnglishResumePreviewDoc from '@/components/format-edit/english-resume/EnglishResumePreviewDoc.vue'
import EnglishResumePreviewDocPage2 from '@/components/format-edit/english-resume/EnglishResumePreviewDocPage2.vue'

const props = withDefaults(
  defineProps<{
    formatData: Record<string, any>
    basicData: Record<string, any>
    previewScale?: number
    currentCardId?: string | string[]
    idPrefix?: string
    isSample?: boolean
  }>(),
  {
    previewScale: 1,
    currentCardId: '',
    idPrefix: '',
    isSample: false
  }
)

const { formLib, deviceLib } = useHostServices()

const cardChanged = ref(false)
let cardChangedTimer: ReturnType<typeof setTimeout> | null = null

const scaleStyle = computed(() => ({
  transform: `scale(${props.previewScale})`,
  'transform-origin': 'top left'
}))

const highlightMessage = computed(() =>
  deviceLib.isMobileDevice ? 'タップで編集' : 'クリックで編集'
)

const jobPages = computed(() =>
  splitJobHistories(props.formatData?.jobHistories)
)
const isTwoPage = computed(() => jobPages.value.isTwoPage)
const jobsPage1 = computed(() => jobPages.value.jobsPage1)
const jobsPage2 = computed(() => jobPages.value.jobsPage2)

const fullName = computed(() => {
  const first = props.basicData?.firstName || ''
  const last = props.basicData?.lastName || ''
  return `${first} ${last}`.trim()
})

const fullAddress = computed(() => props.formatData?.address || '')

const fullPhone = computed(() => {
  const t1 = props.basicData?.tel1 || ''
  const t2 = props.basicData?.tel2 || ''
  const t3 = props.basicData?.tel3 || ''
  if (!t1 && !t2 && !t3) return ''
  return [t1, t2, t3].filter(Boolean).join('-')
})

const formatedCreateDate = computed(() => {
  if (!props.formatData?.createDate) return ''
  return formLib.dateFormat(props.formatData.createDate, 'm/yyyy')
})

function goCardTo(id: string) {
  if (props.isSample) return
  emitter.emit('go-card-to', id)
}

function setJumpId(_nextJumpId: string) {
  cardChanged.value = true
  if (cardChangedTimer) clearTimeout(cardChangedTimer)
  cardChangedTimer = setTimeout(() => {
    cardChanged.value = false
  }, 5000)
}

onMounted(() => {
  emitter.on('show-preview-from-card', setJumpId)
})

onBeforeUnmount(() => {
  emitter.off('show-preview-from-card', setJumpId)
  if (cardChangedTimer) clearTimeout(cardChangedTimer)
})
</script>
